import { StyledLabel } from 'src/components/foundations/foundations.styles';
import {
  Circle,
  Container,
  SwitchContainer,
  SwitchInput,
} from './Switch.styles';

interface Props {
  checked?: boolean;
  label?: string;
  labelPosition?: string;
  disabled?: boolean;
  onClick: (newToggleValue: boolean) => void;
  'data-testid'?: string;
}

export const Switch = ({
  checked,
  disabled,
  onClick,
  label,
  labelPosition = 'left',
  ...props
}: Props) => (
  <Container disabled={disabled}>
    {label && labelPosition === 'left' && (
      <StyledLabel disabled={disabled}>{label}</StyledLabel>
    )}
    <SwitchContainer>
      <SwitchInput
        type="checkbox"
        checked={checked}
        onChange={() => !disabled && onClick(!checked)}
        disabled={disabled}
        data-testid={`${props['data-testid']}-input`}
      />
      <Circle
        checked={checked}
        disabled={disabled}
        onClick={() => !disabled && onClick(!checked)}
        data-testid={props['data-testid']}
      />
    </SwitchContainer>
    {label && labelPosition === 'right' && (
      <StyledLabel disabled={disabled}>{label}</StyledLabel>
    )}
  </Container>
);
